<template>
    <el-drawer
        title="产品详情"
        :close-on-press-escape="false"
        :visible.sync="drawer">
        <span slot="title" class="font14px text-bold">产品详情</span>
        <div class="p20 app-info" v-loading="dataLoading">
            <el-form label-width="150px" label-position="top">
                <el-form-item label="推广名称：">
                    <span class="mr10">{{appDetail.app_name||'-'}}</span>
                </el-form-item>
                <el-form-item label="推广ID：">
                    <span>{{appDetail.app_id||'-'}}</span>
                </el-form-item>
                <el-form-item label="推广内容：">
                    <span>{{appDetail.package_name||'-'}}</span>
                </el-form-item>
                <el-form-item label="项目名称：">
                    <span>{{appDetail.project_name||appDetail.main_app_name||'-'}}</span>
                </el-form-item>
                <el-form-item label="包体类型：">
                    <span>{{appDetail.package_type_name||'-'}}</span>
                </el-form-item>
                <el-form-item label="游戏分类：">
                    <span>{{appDetail.game_classify_name||'-'}}</span>
                </el-form-item>
                <el-form-item label="分包类型：">
                    <span>{{appDetail.subpackage_type_name||'-'}}</span>
                </el-form-item>
                <el-form-item label="开发者主体：">
                    <span>{{appDetail.subproject_tag10_name||'-'}}</span>
                </el-form-item>
                <el-form-item label="集团名称：">
                    <span>{{appDetail.bloc_name||'-'}}</span>
                </el-form-item>
                <el-form-item label="收益类型：">
                    <span>{{appDetail.income_type_name||'-'}}</span>
                </el-form-item>
                <el-form-item label="运营组：">
                    <span>{{appDetail.yy_group_name||'-'}}</span>
                </el-form-item>
                <el-form-item label="运营负责人：">
                    <span>{{appDetail.yy_name||'-'}}</span>
                </el-form-item>
                <el-form-item label="销售负责人：">
                    <span>{{appDetail.xs_name||'-'}}</span>
                </el-form-item>
            </el-form>
        </div>
    </el-drawer>
</template>

<script>
    import API from '@/api/dataCenter/appKpi.js';

    export default {
        name: "AppDetailDrawer",
        props:{
            appData:Object,
            platId:[String,Number]
        },
        data(){
            return{
                drawer:false,
                appDetail:{
                },
                dataLoading:false,
            }
        },
        methods:{
            showDrawer(){
                this.drawer = true;
                this.$nextTick(()=>{
                    this.getAppDetail();
                })
            },
            getAppDetail(){
                this.dataLoading = true;
                API.getAppDetail({
                    plat_id:this.platId,
                    app_id:this.appData.app_id,
                }).then(res => {
                    let resData = res.data||{};
                    this.appDetail = Object.assign({},this.appDetail,resData);
                    this.dataLoading = false;
                }, (err) => {
                    console.log('getAppDetail error', err);
                    this.appDetail = {};
                    this.dataLoading = false;
                });
            },
        }
    }
</script>

<style scoped>
    ::v-deep .el-drawer__header{
        padding: 15px 20px;
        margin: 0;
        border-bottom: solid 1px #dcdee2;
    }

    ::v-deep .el-form-item__label{
        line-height: 20px;
        padding-bottom: 0;
        padding-left: 2em;
    }
    ::v-deep .el-form-item__content{
        line-height: 20px;
        padding-bottom: 0;
        padding-left: 4em;
        font-size: 12px;
        word-wrap: break-word;
    }

    .app-info ::v-deep .el-form-item{
        margin-bottom: 10px;
    }

</style>
